export default function (props) {
    return `
    <div class="detailsPage__wrapper">
        <div id="detailsPage"></div>
    </div>
    `;
}

{/* <div class="details__img"></div>
<div class="details__content">DetailsPageView</div> */}
